<template>
  <div class="space-y-4">
    <!-- Count -->
    <div aria-live="polite" class="text-sm font-medium text-base-content/70">
      {{ t("ui.outputs.itemCount", { count: list.length }) }}
    </div>

    <!-- Read-only list showcase -->
    <transition-group name="fade" tag="ol" role="list" class="list-decimal list-inside space-y-2">
      <li
        v-for="(item, i) in list"
        :key="i"
        class="flex items-center p-4 bg-base-100 rounded-2xl shadow hover:shadow-lg transition-shadow group">
        <span class="flex-1 text-base text-base-content">{{ item }}</span>
        <svg
          class="w-6 h-6 text-primary opacity-0 group-hover:opacity-100 transition-opacity"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 20 20"
          aria-hidden="true">
          <path
            d="M16.707 5.293a1 1 0 00-1.414 0L9 11.586 6.707 9.293a1 1 0 10-1.414 1.414l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414z" />
        </svg>
      </li>
    </transition-group>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
const { t } = useI18n();
const props = defineProps<{
  list: string[];
}>();
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
